import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    deleteDailyRental,
    DeleteDailyRentalResponse,
    createDailyRental,
    CreateDailyRentalBody,
    DailyRentalResponse,
    updateDailyRental,
    UpdateDailyRentalBody,
    UpdateDailyRentalQueries,
    DeleteDailyRentalQueries,
} from '../../services/apiSLTP/dailyReports/dailyRentals';

type UseDeleteDailyRentalMutationOptions = MutationOptions<DeleteDailyRentalResponse, Error, { id: string; queries?: DeleteDailyRentalQueries }>;

export const useDeleteDailyRentalMutation = (options?: UseDeleteDailyRentalMutationOptions) => {
    const deleteDailyRentalMutation: MutationFunction<DeleteDailyRentalResponse, { id: string; queries?: DeleteDailyRentalQueries }> = async ({
        id,
        queries,
    }) => {
        try {
            const response: DeleteDailyRentalResponse = await deleteDailyRental(id, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily tool');
        }
    };

    return useMutation(deleteDailyRentalMutation, options);
};

type UseCreateDailyRentalMutationOptions = MutationOptions<DailyRentalResponse, Error, { body: CreateDailyRentalBody }>;

export const useCreateDailyRentalMutation = (options?: UseCreateDailyRentalMutationOptions) => {
    const createDailyRentalMutation: MutationFunction<DailyRentalResponse, { body: CreateDailyRentalBody }> = async ({ body }) => {
        try {
            const response: DailyRentalResponse = await createDailyRental(body);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily tool');
        }
    };

    return useMutation(createDailyRentalMutation, options);
};

type UseDailyRentalMutationOptions = MutationOptions<
    DailyRentalResponse,
    Error,
    { id: string; body: UpdateDailyRentalBody; queries?: UpdateDailyRentalQueries }
>;

export const useDailyRentalMutation = (options?: UseDailyRentalMutationOptions) => {
    const updateDailyRentalMutation: MutationFunction<
        DailyRentalResponse,
        { id: string; body: UpdateDailyRentalBody; queries?: UpdateDailyRentalQueries }
    > = async ({ id, body, queries }) => {
        try {
            const response: DailyRentalResponse = await updateDailyRental(id, body, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily tool');
        }
    };

    return useMutation(updateDailyRentalMutation, options);
};
